import { render, staticRenderFns } from "./PlanchaMateriales.vue?vue&type=template&id=788df698&scoped=true&"
import script from "./PlanchaMateriales.vue?vue&type=script&lang=ts&"
export * from "./PlanchaMateriales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788df698",
  null
  
)

export default component.exports